const RadioOption = ({ id, name, label, description, checked, onChange }) => (
  <label
    htmlFor={id}
    className={`flex items-center p-4 border rounded-lg cursor-pointer transition-all ${
      checked ? 'bg-blue-50 border-blue-500 ring-2 ring-blue-500' : 'bg-white border-gray-200 hover:bg-gray-50'
    }`}
  >
    <input
      id={id}
      type="radio"
      name={name}
      value={id}
      checked={checked}
      onChange={() => onChange(id)}
      className="h-4 w-4 text-blue-600 border-gray-300 focus:ring-blue-500"
    />
    <span className="ml-3 flex flex-col">
      <span className="block text-base font-medium text-gray-800">{label}</span>
      <span className="block text-sm text-gray-500">{description}</span>
    </span>
  </label>
);
export default RadioOption;